import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@chakra-ui/react';
import ProgramFilter from './ProgramFilter';
import ProgramList from './ProgramList';
import {
  ProgramInfo,
  useGetAllProgramInfoQuery,
} from '../../../generated/graphqlModels';

const ProgramTable = () => {
  const { data: programInfos, loading } = useGetAllProgramInfoQuery({
    errorPolicy: 'ignore',
  });
  const [filteredProgramInfos, setFilteredProgramInfos] = useState<
    ProgramInfo[]
  >([]);

  useEffect(() => {
    if (programInfos?.programInfos) {
      setFilteredProgramInfos(programInfos.programInfos as any);
    }
  }, [programInfos]);

  return (
    <Stack
      id="program-table"
      color="white"
      flexDir={'column'}
      mt={{ base: '0px' }}
      spacing={0}
      gap={[8, 8, 8, 16]}
      mb={16}
    >
      <Box>
        <ProgramFilter
          setFilteredProgramInfos={setFilteredProgramInfos}
          programInfos={(programInfos?.programInfos as any) || []}
        />
      </Box>
      <Box flex="1" mt="20px">
        <ProgramList programInfos={filteredProgramInfos} isLoading={loading} />
      </Box>
    </Stack>
  );
};

export default ProgramTable;
